import {useMemo} from 'react'

import {
  useCurrentStoragesWithMaterialQuery,
  useHistoryAssetsQuery,
  useMaterialsRecipesById
} from '../../../../shared/hooks/api'
import {getOptimizedMaterialIdsWithStorages} from '../../../../shared/selectors/storageLevels'
import {usePlanningChartStartEnd} from '../../../page-planning/dailyPlanning/PlanningChartStartEndProvider'

export function useGetOptimizedMaterialIds() {
  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()

  const {data: storagesWithMaterial} = useCurrentStoragesWithMaterialQuery()
  const {data: assets} = useHistoryAssetsQuery({timeFrame: [startOfPlan, endOfPlan]})
  const {data: recipesById} = useMaterialsRecipesById()
  return useMemo(
    () =>
      assets && recipesById && storagesWithMaterial
        ? getOptimizedMaterialIdsWithStorages({assets, recipesById, storagesWithMaterial})
        : undefined,
    [recipesById, assets, storagesWithMaterial]
  )
}
